/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* CLIM campaign messages: session-only, allowlisted; no analytics events added. */
(function () {
  'use strict';
  var messages = {
    'G-HUN': 'Hola CLIM, vi su anuncio de ventiladores Hunter y quiero una cotización. [G-HUN]',
    'G-MIN': 'Hola CLIM, vi su anuncio de ventiladores Minka-Aire y quiero una cotización. [G-MIN]',
    'G-VC': 'Hola CLIM, vi su anuncio de Maverick de Visual Comfort y quiero una cotización. [G-VC]',
    'G-HAI': 'Hola CLIM, vi su anuncio de Haiku de Big Ass Fans y quiero una cotización. [G-HAI]'
  };
  var storageKey = 'clim_whatsapp_campaign_v1';
  var params = new URLSearchParams(location.search);
  var values = params.getAll('clim_campaign');
  var code = values.length === 1 && Object.prototype.hasOwnProperty.call(messages, values[0]) ? values[0] : '';
  var otherSource = false;
  params.forEach(function (_, key) {
    if (/^utm_/i.test(key) || /^(gclid|dclid|gbraid|wbraid|fbclid|msclkid|ttclid|srsltid)$/i.test(key)) otherSource = true;
  });
  var externalVisit = false;
  try { externalVisit = !!document.referrer && new URL(document.referrer).origin !== location.origin; } catch (_) {}
  try {
    var previous = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
    if (!values.length && !otherSource && !externalVisit && previous &&
        Object.prototype.hasOwnProperty.call(messages, previous.code) &&
        Date.now() - previous.seen < 30 * 60 * 1000) code = previous.code;
    if (code) sessionStorage.setItem(storageKey, JSON.stringify({code: code, seen: Date.now()}));
    else sessionStorage.removeItem(storageKey);
  } catch (_) {}
  if (!code) return;

  function prepare(link) {
    // Pushdaddy is managed separately; do not override its widget from the theme.
    if (link.closest('[id^="pushdaddy"], [class*="pushdaddy"]')) return;
    var raw = link.getAttribute('href');
    if (!raw) return;
    try {
      var url = new URL(raw, location.href);
      if (!/^(wa\.me|api\.whatsapp\.com|web\.whatsapp\.com)$/.test(url.hostname)) return;
      if (!/^https?:$/.test(url.protocol)) return;
      url.searchParams.set('text', messages[code]);
      if (link.href !== url.href) link.setAttribute('href', url.href);
    } catch (_) {}
  }
  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches('a[href]')) prepare(root);
    root.querySelectorAll('a[href]').forEach(prepare);
  }
  scan(document);
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      if (record.type === 'attributes') prepare(record.target);
      else record.addedNodes.forEach(scan);
    });
  }).observe(document.documentElement, {subtree: true, childList: true, attributes: true, attributeFilter: ['href']});
})();
